/*
 * @Author: gang.liu
 * @Date: 2021-06-28 09:21:03
 * @LastEditTime: 2021-06-29 14:15:39
 * @LastEditors: gang.liu
 * @Description:
 * @api-property:
 * @api-event:
 * @api-method:
 */
import Vue from "vue";
import VueRouter from "vue-router";
import register from "@/router/routes/register";
import login from "@/router/routes/login";
import home from "@/router/routes/home";
import consultative from "@/router/routes/consultative";
import publicRoute from "@/router/routes/public";
import chineseMedicineRoute from "@/router/routes/chineseMedicine";
import contactUsRoute from "@/router/routes/contactUs";
import retrievePassword from "@/router/routes/retrievePassword"
import medicine from "@/router/routes/medicine";
// import partnersRoute from "@/router/routes/partners";

Vue.use(VueRouter);

const routes = [home, register, login, consultative, publicRoute,chineseMedicineRoute,contactUsRoute,retrievePassword,medicine
  // partnersRoute //注释合作伙伴
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
